import BackButton from "../components/BusinessListing/BusinessListingDetails/BackButton";
import BusinessAddress from "../components/BusinessListing/BusinessListingDetails/BusinessAddress";
import BusinessHours from "../components/BusinessListing/BusinessListingDetails/BusinessHours";
import BusinessImageSlider from "../components/BusinessListing/BusinessListingDetails/BusinessImageSlider";
import BusinessMap from "../components/BusinessListing/BusinessListingDetails/BusinessMap";
import BusinessSlider from "../components/BusinessListing/BusinessListingDetails/BusinessSlider";
import BusinessWebsite from "../components/BusinessListing/BusinessListingDetails/BusinessWebsite";
import Container from "../components/layout/Container";
import BannerAds from "../components/Shared/BannerAds/BannerAds";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";

const BusinessListingDetails = () => {
  return (
    <Container>
      <BusinessSlider />
      <div className="grow">
        <FilterHeader title={"BUISNESS LISTING DISPLAY"} dropdown={false} />
      </div>
      <BackButton />
      <BusinessImageSlider />
      <BusinessAddress/>
      <BusinessHours/>
      <BusinessWebsite/>
      <BusinessMap />
      <div className="mt-[80px] grid grid-cols-3 gap-10">
        <BannerAds />
        <BannerAds />
        <BannerAds />
      </div>
    </Container>
  );
};

export default BusinessListingDetails;
